import { render, staticRenderFns } from "./WorkplaceOrServiceSelect.vue?vue&type=template&id=10045ae6&scoped=true&"
import script from "./WorkplaceOrServiceSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkplaceOrServiceSelect.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WorkplaceOrServiceSelect.vue?vue&type=style&index=0&id=10045ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10045ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10045ae6')) {
      api.createRecord('10045ae6', component.options)
    } else {
      api.reload('10045ae6', component.options)
    }
    module.hot.accept("./WorkplaceOrServiceSelect.vue?vue&type=template&id=10045ae6&scoped=true&", function () {
      api.rerender('10045ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceSelect/WorkplaceOrServiceSelect.vue"
export default component.exports